import "../styles/vars.scss";
import LayoutPage from "./Layout";
import SettingProfile from "../ui/compoP/SettingProfile";
import SettingEmail from "../ui/compoP/SettingEmail";
import SettingPassword from "../ui/compoP/SettingPassword";
import SettingAccount from "../ui/compoP/SettingAccount";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  currentUser,
  isAuthenticated,
  refreshCurrentUser,
  ensureAuthHydrated,
  normalizeUserRecord,
} from "../auth/authApi";
import SettingCenterBar from "../ui/compoP/CenterBars/SettingCenterBar";

function Setting() {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [activeSection, setActiveSection] = useState(() => {
    return localStorage.getItem("settingActiveSection") || "profile";
  });
  let userTokenPresent = isAuthenticated();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        await ensureAuthHydrated();
        if (isAuthenticated()) {
          const cached = currentUser();
          if (cached) setUserData(normalizeUserRecord(cached));
          const me = await refreshCurrentUser();
          const record = me || currentUser();
          setUserData(record ? normalizeUserRecord(record) : null);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        const fallback = currentUser();
        if (fallback) setUserData(normalizeUserRecord(fallback));
      }
    };

    // If not authenticated, redirect to home and prevent rendering settings
    if (!userTokenPresent) {
      navigate("/", { replace: true });
      return;
    }

    if (userTokenPresent) {
      fetchUserData();
    }
  }, [userTokenPresent]);

  const handleSectionChange = (section) => {
    setActiveSection(section);
    localStorage.setItem("settingActiveSection", section);
  };

  return (
    <div className="setting-page">
      
      {/* Profile Section */}
      {activeSection === "profile" && (
        <LayoutPage
          centerBar={
          
              <SettingCenterBar
                activeSection={activeSection}
                handleSectionChange={handleSectionChange}
                title="Setting"
                icon="setting"
              />
        
          }
        >
    
            <SettingProfile
              userData={userData}
              title="Profile"
              icon="namecard"
            />
      
        </LayoutPage>
      )}

      {/* Email Section */}
      {activeSection === "email" && (
        <LayoutPage
          centerBar={
       
              <SettingCenterBar
                activeSection={activeSection}
                handleSectionChange={handleSectionChange}
                title="Setting"
                icon="setting"
              />
        
          }
          title="Profile"
          icon="namecard"
          
        >
          <SettingEmail
            userData={userData}
            onEmailUpdated={(me) => {
              if (me) setUserData(normalizeUserRecord(me));
            }}
            title="Email Address"
            icon="new_mail"
            content={
              <>
                Your current email is :{" "}
                <span>{userData?.email || "info@pinjob.me"}</span>
              </>
            }
          />
        </LayoutPage>
      )}

      {/* Password Section */}
      {activeSection === "password" && (
        <LayoutPage
          centerBar={
     
              <SettingCenterBar
                activeSection={activeSection}
                handleSectionChange={handleSectionChange}
                title="Setting"
                icon="setting"
              />
        
          }
        >
          <SettingPassword
            title="Password"
            icon="new_password"
            content={
              <>
                Your new password must be different to previously used
                passwords.
                <br />
                Password must be at least 6 characters.
              </>
            }
          />
        </LayoutPage>
      )}

      {/* Account Section */}
      {activeSection === "account" && (
        <LayoutPage
          centerBar={
         
              <SettingCenterBar
                activeSection={activeSection}
                handleSectionChange={handleSectionChange}
                title="Setting"
                icon="setting"
              />
         
          }
          title="Profile"
          icon="account"
        >
          <SettingAccount
            title="Delete Account"
            icon="account"
            content={
              <>
                Be aware that deleting your profile will result in the permanent
                loss of all your data.
                <br />
                This action is irreversible and cannot be undone.
              </>
            }
          />
        </LayoutPage>
      )}
    </div>
  );
}

export default Setting;
